import MeetingConnectList from './MeetingConnectList';

export default MeetingConnectList;
